import { ga } from '../../../engine/ga-sidecar'
import { settings } from '../../../engine/settings-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { clickEater } from '../../../uiParts/clickEater-sidecar'
import { stevieTexts2 } from '../../../uiParts/stevieTexts2-sidecar'
import { chessAiRando } from '../ai/chessAiRando-sidecar'
import { chessCamera } from '../chessCamera-sidecar'
import { chessLayers } from '../chessLayers-sidecar'
import { chessMusic } from '../sound/chessMusic-sidecar'
import { chessSounds } from '../sound/chessSounds-sidecar'
import { chessFonts } from './chessFonts-sidecar'
import type { IChessUiCanvas } from './chessUiCanvas'
import { chessUiCanvas } from './chessUiCanvas-sidecar'
import { chessUiGButtons } from './chessUiGButtons-sidecar'
import { chessUiGraphicsUtils } from './chessUiGraphicsUtils-sidecar'
import type { IChessUiGSelector } from './chessUiGSelectors'
import { chessUiGSelectors } from './chessUiGSelectors-sidecar'

interface IChessUiSettings extends IChessUiCanvas {
  selectorMusic: IChessUiGSelector | null
  selectorSound: IChessUiGSelector | null
}
let _obj: IChessUiSettings | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    createButtons()
    setOpen(false)
    render()
  }
  return _obj
}

const create = () => {
  let tw = 600
  let th = 700

  let canvas = chessUiCanvas.create(tw, th, chessLayers.getLayers().uiMessage)
  canvas.autoOffset = false

  let obj: IChessUiSettings = chessUiCanvas.assign<IChessUiSettings>(canvas, {
    selectorMusic: null,
    selectorSound: null,
  })

  return obj
}

export const soundSettings = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
]

const createButtons = () => {
  let obj = get()
  obj.buttons = [
    chessUiGButtons.create('Cancel', 50, 50, () => {
      ga.action('click', 'ai-cancel')
      chessAiRando.killAll()
      setOpen(false)
    }),
    chessUiGButtons.create('Ok', 250, 50, () => {
      ga.action('click', 'ai-ok')
      setOpen(false)

      assert.notNil(obj.selectorMusic)
      assert.notNil(obj.selectorSound)

      // let aiBrainSpeed = parseFloat(obj.selectorAiBrainSpeed.value)
    }),
  ]

  let sw = 520 - 200 - 80 + 100
  let lw = 250 - 100 + 100

  obj.selectors = [
    (obj.selectorMusic = chessUiGSelectors.create(
      'Music volume',
      soundSettings,
      100,
      100,
      sw,
      lw,
    )),
    (obj.selectorSound = chessUiGSelectors.create(
      'Sound volume',
      soundSettings,
      100,
      100,
      sw,
      lw,
    )),
  ]

  obj.selectorMusic.onChange = () => {
    assert.notNil(obj.selectorMusic)
    chessMusic.setVolume(parseInt(obj.selectorMusic.value))
  }
  obj.selectorSound.onChange = () => {
    assert.notNil(obj.selectorSound)
    chessSounds.setVolume(parseInt(obj.selectorSound.value))
  }

  chessUiGSelectors.setValue(obj.selectorMusic, '' + settings.get().musicVolume)
  chessUiGSelectors.setValue(obj.selectorSound, '' + settings.get().soundVolume)
}

const render = () => {
  let obj = get()
  let g = obj.graphics

  chessUiCanvas.clear(obj)

  let addText = (text: string, x: number, y: number) => {
    let _text = stevieTexts2.create(chessFonts.get().f, x, y, obj.layer)
    stevieTexts2.setText(_text, text)
    stevieTexts2.setScale(_text, 0.4)
    obj.texts.push(_text)
    return _text
  }

  g.clear()

  let gb = chessCamera.getGameBounds()

  g.fillStyle(0x222222, 0.67)
  g.fillRect(0, 0, gb.width, gb.height)

  let w = obj.targetWidth
  let h = obj.targetHeight

  let x = (gb.width - w) / 2
  let y = (gb.height - h) / 2

  chessUiGraphicsUtils.bevelPanel(g, x, y, w, h)

  let title = addText('Settings', x + 6, y)
  stevieTexts2.setScale(title, 0.6)

  x += 10
  y += 40
  obj.selectors[0].x = x
  obj.selectors[0].y = y

  y += 60
  obj.selectors[1].x = x
  obj.selectors[1].y = y

  // y += 60
  // obj.selectors[2].x = x
  // obj.selectors[2].y = y

  // y += 60
  // obj.selectors[3].x = x
  // obj.selectors[3].y = y

  x = (gb.width - w) / 2
  y = (gb.height - h) / 2
  x += 20
  y += h - 60
  obj.buttons[0].x = x
  obj.buttons[0].y = y
  obj.buttons[1].x = x + 200
  obj.buttons[1].y = y

  chessUiCanvas.render(obj)
}

export const setOpen = (isOpen: boolean, onOk = () => {}) => {
  let obj = get()
  chessUiCanvas.setOpen(obj, isOpen)
  if (isOpen) {
    update()
  }
}

export const update = () => {
  let obj = get()

  if (obj.isOpen) {
    chessUiCanvas.update(obj)
    render()
    clickEater.tempEatCursor()
  } else {
    chessUiCanvas.clear(obj)
  }
}
